import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout.vue';

/**
 * app跳转路由转发统一地址
 */
var virtual = {
  path: '/forward',
  component: RootLayout,
  redirect: '/forward',
  children: [{
    path: '/forward',
    name: 'Forward',
    component: function component() {
      return import('views/forward/index');
    },
    meta: {
      title: ''
    }
  }]
};
export default virtual;